import React from "react";
const SquareFrame = (props) => {
  const { children } = props;
  return /* @__PURE__ */ React.createElement("div", { className: "square-frame" }, /* @__PURE__ */ React.createElement("div", { className: "square-frame__face" }, children));
};
export default SquareFrame;
